module.exports = __webpack_public_path__ + "img/mockPhotoBig.16a5f30b.jpg";